import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useSupplyChainStepTypes = defineStore('supply-chain-step-types', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.supplyChainStepType_List,
    dto: 'SupplyChainStepTypeDto',
    create: api.supplyChainStepType_Create,
    update: api.supplyChainStepType_Update,
    delete: api.supplyChainStepType_Delete,
    signalR: 'SupplyChainStepTypeUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
